import { render, staticRenderFns } from "./index.vue?vue&type=template&id=697e80eb&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=697e80eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697e80eb",
  null
  
)

export default component.exports